export const DISCIPLINES = [
  { v: "singles", l: "Singles" },
  { v: "doubles", l: "Doubles" },
];

export const SKILLS = [
  { v: "open", l: "Open" },
  { v: "3.0", l: "3.0" },
  { v: "3.5", l: "3.5" },
  { v: "4.0+", l: "4.0+" },
];

export const GENDERS = [
  { v: "mens", l: "Men's" },
  { v: "womens", l: "Women's" },
  { v: "mixed", l: "Mixed" },
];

export const FORMATS = [
  { v: "single_elim", l: "Single Elimination" },
  { v: "double_elim", l: "Double Elimination" },
  { v: "round_robin", l: "Round Robin" },
];

export const PLAYOFF_FORMATS = [
  { v: "single_elim", l: "Single Elimination" },
  { v: "double_elim", l: "Double Elimination" },
  { v: "round_robin", l: "Round Robin" },
  { v: "none", l: "No playoffs" },
];

export const CURRENCIES = [
  { v: "PHP", l: "PHP ₱" },
  { v: "USD", l: "USD $" },
  { v: "EUR", l: "EUR €" },
  { v: "AUD", l: "AUD A$" },
  { v: "SGD", l: "SGD S$" },
];

export const CURRENCY_SYMBOLS = { PHP: "₱", USD: "$", EUR: "€", AUD: "A$", SGD: "S$" };

export const STATUS_META = {
  draft: { l: "Draft", color: "#94a3b8" },
  published: { l: "Published", color: "#22c55e" },
  live: { l: "Live", color: "#06b6d4" },
  completed: { l: "Completed", color: "#eab308" },
};

const map = (arr, v) => arr.find((x) => x.v === v)?.l || v;
export const labelDiscipline = (v) => map(DISCIPLINES, v);
export const labelSkill = (v) => map(SKILLS, v);
export const labelGender = (v) => map(GENDERS, v);
export const labelFormat = (v) => map(FORMATS, v);
export const labelPlayoffFormat = (v) => map(PLAYOFF_FORMATS, v);

export function categoryLabel(c) {
  return c.name || `${labelGender(c.gender)} ${labelDiscipline(c.discipline)} · ${labelSkill(c.skill_level)}`;
}

export function fmtMoney(currency, n) {
  const sym = CURRENCY_SYMBOLS[currency] || "";
  return `${sym}${Number(n || 0).toLocaleString()}`;
}

export function fmtDate(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); }
  catch (e) { return iso; }
}

export const PAYMENT_STATUS_META = {
  pending: { l: "Pending", color: "#eab308" },
  confirmed: { l: "Confirmed", color: "#06b6d4" },
  paid: { l: "Paid", color: "#22c55e" },
  paid_confirmed: { l: "Paid + Confirmed", color: "#a78bfa" },
  rejected: { l: "Rejected", color: "#ef4444" },
};

export const REJECTION_REASONS = [
  "Playing level not appropriate for this category — please choose another category",
  "Payment not received / proof of payment invalid",
  "Category is full",
  "Incomplete or incorrect registration details",
  "Partner not confirmed / partner registration missing",
  "Does not meet age or gender requirements for this category",
];

export function canCreateTournaments(user) {
  if (!user) return false;
  if (["admin", "super_admin"].includes(user.role)) return true;
  if (user.capabilities) return !!user.capabilities.ts_event;
  // legacy fallback
  if (user.account_type === "player") return false;
  if (!["club_pro", "umpire"].includes(user.license_tier)) return false;
  if (user.license_expires) {
    const today = new Date().toISOString().slice(0, 10);
    if (user.license_expires < today) return false;
  }
  return true;
}

export function hasCapability(user, cap) {
  if (!user) return false;
  if (["admin", "super_admin"].includes(user.role)) return true;
  if (user.capabilities) return !!user.capabilities[cap];
  return false;
}

export const CAP_LABELS = {
  tournaments: "Tournament Suite",
  open_play: "Open Play sessions",
  player_directory: "Player Directory",
  umpire: "Umpire consoles",
  live_views: "TV / Spectator views",
};

// Returns subscription lifecycle state for an organizer account.
// state: 'active' | 'expiring' | 'expired' | 'none'
export function subscriptionStatus(user, warnDays = 7) {
  if (!user) return { state: "none", daysLeft: null, expires: null };
  if (user.account_type === "player") return { state: "none", daysLeft: null, expires: null };
  if (["admin", "super_admin"].includes(user.role)) return { state: "active", daysLeft: null, expires: null };
  const licensed = ["club_pro", "umpire"].includes(user.license_tier);
  if (!licensed) return { state: "none", daysLeft: null, expires: null };
  const exp = user.license_expires;
  if (!exp) return { state: "active", daysLeft: null, expires: null };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expDate = new Date(`${exp}T00:00:00`);
  const daysLeft = Math.round((expDate - today) / 86400000);
  if (daysLeft < 0) return { state: "expired", daysLeft, expires: exp };
  if (daysLeft <= warnDays) return { state: "expiring", daysLeft, expires: exp };
  return { state: "active", daysLeft, expires: exp };
}

// Short display name for tight UI spaces: "Anna Leigh Waters" -> "WATERS, A.L."
export function shortName(name) {
  if (!name) return "";
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length <= 1) return (parts[0] || "").toUpperCase();
  const last = parts[parts.length - 1];
  const firsts = parts.slice(0, -1);
  return `${last.toUpperCase()}, ${firsts.map((w) => w[0].toUpperCase()).join(".")}.`;
}

// Short display for a team entrant that may be "Player / Partner".
export function shortTeam(name) {
  if (!name) return "";
  return String(name).split(/\s*\/\s*/).map(shortName).join(" / ");
}
